module.exports = __webpack_public_path__ + "img/csxy-logo.9dbf256a.png";